/**
 * @generated SignedSource<<e91e20f3fb1d0c82c7279249a4ac22bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priority_softwareReleasesVersionDetailIssueList$data = {
  readonly priority: {
    readonly iconUrl: AGG$URL;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "priority_softwareReleasesVersionDetailIssueList";
};
export type priority_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: priority_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"priority_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priority_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "iconUrl"
          },
          "action": "NONE",
          "path": "priority.iconUrl"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "ab255857fbd72fa53e70fe6a619699a6";

export default node;
